type EditPreset = {
  label: string
  instruction: string
}

export const EDIT_PRESETS: EditPreset[] = [
  { label: 'Polish writing', instruction: 'Improve the clarity, flow, and readability of this text while preserving the original meaning and tone.' },
  { label: 'Shorten', instruction: 'Shorten this text while preserving the key points.' },
  { label: 'Proofread', instruction: 'Fix any spelling, grammar, and punctuation errors in this text without changing the meaning or style.' },
]
